// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8445 ? "bc98253f" : chunkId) + "." + {"5243":"302ed1751644700f","8445":"75c6412bdb10a1f9","8848":"6edd26dd315f0a67"}[chunkId] + ".js";
};